import React, { useEffect, useState } from 'react';
import config from "../../config";
import axios from "axios";
import './Pre-AssessmentQuestions.css';
import PreAssessmentQuestionsMobile from "./PreAssessmentQuestionsMobile/PreAssessmentQuestionsMobile";
import {useTranslation} from "react-i18next";
import scrollToTop from "../../scripts/scroll-to-top";

function PreAssessmentQuestions(props) {
    const { t, i18n } = useTranslation();

    const [fields, setFields] = useState({})
    const [q1, setQ1] = useState('');
    const [q2, setQ2] = useState('');
    const [requiredFiledError, setRequiredFiledError] = useState(false);
    const [isMobileScreen, setIsMobileScreen] = useState(false);
    const [loaderIsActive, setLoaderIsActive] = useState(false);

    const getPageContent = async () => {
        try {
            const response = await axios.post(
                config.API_URL_FOR_LOCAL_DEVELOPMENT + '/api/v1/pre-assessment/questions/fields',
                {
                    language: config.LANGUAGE || 'en',
                }
            );

            setFields(response.data.fields);
        } catch (error) {
            console.error('Error while retrieving data:', error);
        }
    }

    const submitForm = async () => {
        setRequiredFiledError(false);

        if (!q1 || (q1 === 'Yes' && !q2)) {
            setRequiredFiledError(true);
            return
        }

        if (q2 === 'Pregnant') {
            props.openModal(t("Pregnancy Error"));
            return;
        }

        try {
            setLoaderIsActive(true);

            await axios.post(
                config.API_URL_FOR_LOCAL_DEVELOPMENT + '/api/v1/pre-assessment/questions/store',
                {
                    q1,
                    q2,
                    incompleteAssessment: q1 === 'No',
                    language: config.LANGUAGE || 'en',
                    landingUserId: window.localStorage.getItem('landingUserId'),
                }
            );

            props.setNewCurrentStep(2);
        } catch (error) {
            console.error('Error while sending data:', error);
        } finally {
            setLoaderIsActive(false);
        }
    }

    const convertObjToArr = (obj) => {
        return Object.entries(obj).map(([key, value]) => ({
            value: key,
            label: value
        }))
    }

    useEffect(() => {
        scrollToTop();
        getPageContent();
    }, [])

    useEffect( () => {
        if (document.body.clientWidth < 1100) setIsMobileScreen(true);

        window.addEventListener("resize", () => {
            document.body.clientWidth < 1100 ? setIsMobileScreen(true) : setIsMobileScreen(false);
        });

    }, [])

    if (fields && fields['q1'] && fields['q2'] && fields['q2'].options) {
        return (
            <div className="PreAssessmentQuestions">

                {
                    isMobileScreen &&
                    <PreAssessmentQuestionsMobile
                        fields={fields}
                        setNewCurrentStep={props.setNewCurrentStep}
                        openModal={props.openModal}
                    />
                }

                {
                    !isMobileScreen &&
                    <div>
                        <h1 className='title-1 mb-4 text-center'>{t('Thank You')} {window.localStorage.getItem('name') || ''}, {t('Get Started')}</h1>

                        <div className='position-relative'>
                            <div className={q1 === 'Yes' ? 'double d-flex align-items-baseline flex-wrap flex-md-nowrap gap-2' : 'single'}>
                                <div className='box-1'>
                                    <div className={'label-1 mb-2 ' + (q1 === 'Yes' ? 'text-left' : 'text-center')}>
                                        {fields['q1'].label}
                                    </div>

                                    <label className='d-flex mb-15'>
                                        <input
                                            className='d-none'
                                            type="radio"
                                            name="q1"
                                            checked={q1 === 'Yes'}
                                            onChange={(e) => setQ1('Yes')}
                                        />

                                        <div
                                            className={q1 === 'Yes' ? 'checkbox-1 checkbox-1--checked mr-15' : 'checkbox-1 mr-15'}
                                            role='button'
                                        ></div>

                                        <span role='button'>{fields['q1']?.options['Yes']}</span>
                                    </label>

                                    <label className='d-flex mb-15'>
                                        <input
                                            className='d-none'
                                            type="radio"
                                            name="q1"
                                            checked={q1 === 'No'}
                                            onChange={(e) => setQ1('No')}
                                        />

                                        <div
                                            className={q1 === 'No' ? 'checkbox-1 checkbox-1--checked mr-15' : 'checkbox-1 mr-15'}
                                            role='button'
                                        ></div>

                                        <span role='button'>{fields['q1'].options['No']}</span>
                                    </label>
                                </div>

                                {
                                    q1 && q1 === 'Yes' &&
                                    <div className='box-1'>
                                        <div className='label-1 mb-2'>
                                            {fields['q2'].label}
                                        </div>

                                        <div className='row'>
                                            <div className='col-12 col-xxl-6'>
                                                {
                                                    fields['q2'] && convertObjToArr(fields['q2'].options)
                                                        .splice(0, 4)
                                                        .map((option, index) => (
                                                            <div key={index}>
                                                                <label className='d-flex mb-2'>
                                                                    <input
                                                                        className='d-none'
                                                                        type="radio"
                                                                        name="q2"
                                                                        checked={q2 === option.value}
                                                                        onChange={(e) => setQ2(option.value)}
                                                                    />

                                                                    <div
                                                                        className={q2 === option.value ? 'checkbox-1 checkbox-1--checked mr-15' : 'checkbox-1 mr-15'}
                                                                        role='button'
                                                                    ></div>

                                                                    <span role='button'>{option.label}</span>
                                                                </label>
                                                            </div>
                                                        ))
                                                }
                                            </div>

                                            <div className='col-12 col-xxl-6'>
                                                {
                                                    fields['q2'] && convertObjToArr(fields['q2'].options)
                                                        .splice( 4, 4)
                                                        .map((option, index) => (
                                                            <div key={index}>
                                                                <label className='d-flex mb-2'>
                                                                    <input
                                                                        className='d-none'
                                                                        type="radio"
                                                                        name="q2"
                                                                        checked={q2 === option.value}
                                                                        onChange={(e) => setQ2(option.value)}
                                                                    />

                                                                    <div
                                                                        className={q2 === option.value ? 'checkbox-1 checkbox-1--checked mr-15' : 'checkbox-1 mr-15'}
                                                                        role='button'
                                                                    ></div>

                                                                    <span role='button'>{option.label}</span>
                                                                </label>
                                                            </div>
                                                        ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                            {
                                q1 && ((q1 === 'No') || (q1 === 'Yes' && q2)) &&
                                <div className='box-1 mt-2'>
                                    <p>{t('PreAssessment Step 3 Content')}</p>
                                </div>
                            }

                            <footer className='mt-5'>
                                {
                                    requiredFiledError &&
                                    <div className='form-error mb-15 text-center'>{t('Complete the required field')}</div>
                                }

                                <div className='d-flex justify-content-center align-items-center'>
                                    <button
                                        className='button-1 mr-6'
                                        onClick={() => props.handleBack(0)}
                                    >
                                        {t("Back Button")}
                                    </button>

                                    <button
                                        className='button-1'
                                        onClick={() => submitForm()}
                                    >
                                        {t("Continue Button")}
                                    </button>
                                </div>
                            </footer>
                        </div>

                        {loaderIsActive && <div className='submitting-overlay'></div>}
                    </div>
                }
            </div>
        );
    } else {
        return (
            <div className='submitting-overlay-container position-relative'>
                <div className="submitting-overlay"></div>
            </div>
        )
    }
}

export default PreAssessmentQuestions;
